// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { DeedType } from "le-coffre-resources/dist/Notary";
import type { QueryPayload } from "../../../types";
import type {
	IGetDeedTypesParams,
	IPutDeedTypesParams,
	IPostDeedTypesParams,
	DeedTypeListSettings,
	DeedTypeListSettingsPayload,
} from "./DeedTypes";
import {
	createGetMethod,
	createGetByUidMethod,
	createPutMethod,
	createPostMethod,
	createGetListSettingsMethod,
	createPutListSettingsMethod,
} from "./helpers/deedTypesMethodsHelpers";

interface DeedTypesInstance {
	get(q?: IGetDeedTypesParams): Promise<DeedType[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<DeedType>;
	put(uid: string, body: IPutDeedTypesParams): Promise<DeedType>;
	post(body: IPostDeedTypesParams): Promise<DeedType>;
	getListSettings(uid: string): Promise<DeedTypeListSettings | null>;
	putListSettings(uid: string, body: DeedTypeListSettingsPayload): Promise<DeedTypeListSettings>;
}

// Module-level singleton instance
let instance: DeedTypesInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createDeedTypes(): DeedTypesInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const baseUrl = baseNotary.namespaceUrl.concat("/deed-types");

	return {
		get: createGetMethod(baseNotary, baseUrl),
		getByUid: createGetByUidMethod(baseNotary, baseUrl),
		put: createPutMethod(baseNotary, baseUrl),
		post: createPostMethod(baseNotary, baseUrl),
		getListSettings: createGetListSettingsMethod(baseNotary, baseUrl),
		putListSettings: createPutListSettingsMethod(baseNotary, baseUrl),
	};
}

export function getDeedTypesInstance(): DeedTypesInstance {
	if (!instance) {
		instance = createDeedTypes();
	}
	return instance;
}
